import dat from 'dat.gui'

export const gui = new dat.GUI()
gui.close()

export let guiObj = {
  focus: 1.0,
  aperture: 0.025,
  maxblur: 0.01
}